/**
 * Faz 9 hata metinleri — Arapça (yapay zekâ, İçerik Stüdyosu, SEO önerileri, YouTube…). Vitrin girişi de hata
 * metinlerini gördüğü için `shared.ar.ts` → `errorsAr` içine yayılmak üzere hazırlanmıştır (Faz 8 düzeniyle aynı; panel
 * metinleri `ai.ar.ts`'de). Terimler: docs/I18N_GLOSSARY.md.
 */
export const aiErrorsAr = {
  youtube_not_configured: 'YouTube غير متصل أو لم يُختبر. أدخل مفتاح API من شاشة التكاملات واختبره.',
  youtube_key_format:
    'صيغة مفتاح API غير صحيحة (Google Cloud ← بيانات الاعتماد ← مفتاح API؛ يبدأ بـ «AIza» ويتكون من 39 حرفًا).',
  youtube_key_invalid: 'لم تقبل Google مفتاح API هذا.',
  youtube_key_restricted:
    'المفتاح مقيَّد: قيد المتصفح (مُحيل HTTP) أو قيد التطبيق يمنع استخدامه من الخادم. استخدم قيد IP على المفتاح وقصره على YouTube Data API فقط.',
  youtube_api_disabled: 'واجهة YouTube Data API v3 غير مفعّلة في مشروع Google Cloud. فعّلها من مكتبة API.',
  youtube_quota: 'استُنفدت الحصة اليومية لـ YouTube؛ أعد المحاولة غدًا.',
  youtube_unreachable: 'تعذّر الوصول إلى YouTube أو قراءة رده. أعد المحاولة لاحقًا.',
  merchant_title_claims: 'لا يجوز أن يتضمن عنوان Google ادعاءات بالوقاية من الأمراض أو علاجها.',
  merchant_title_too_long: 'يمكن أن يتكون عنوان Google من 150 حرفًا كحد أقصى.',
  copilot_days: 'يجب أن تكون الفترة 7 أو 30 أو 90 يومًا.',
  copilot_question_required: 'اكتب سؤالك في 3 أحرف على الأقل.',
  ai_translation_source_invalid: 'المقال المصدر ليس ضمن مجموعة ترجمات هذا المقال.',
  ai_translation_too_long: 'المقال أطول من أن يُترجم دفعة واحدة (40,000 حرف كحد أقصى).',
  ai_email_goal_required: 'اكتب هدف الحملة في 10 أحرف على الأقل.',
  ai_support_drafts_disabled:
    'مسودات ردود الدعم متوقفة. يمكن لمالك النشاط تفعيلها من إعدادات الذكاء الاصطناعي (تُرسل رسالة العميل بعد إخفاء بياناتها الشخصية).',
  studio_image_alt_required: 'يجب أن يكون لكل صورة مضافة إلى المسودة نص بديل: ![النص البديل](zt-file:…).',
  ai_image_prompt_invalid: 'يجب أن يتراوح طول وصف الصورة بين 10 و1000 حرف.',
  ai_image_invalid:
    'تعذّرت قراءة الصورة التي أعادها المزوّد؛ وإذا احتُسبت رسومها فستظهر في تقرير الاستخدام. أعد المحاولة.',
  ai_provenance_locked: 'لا يمكن تغيير مصدر الصورة المُنشأة بالذكاء الاصطناعي.',
  file_not_image: 'الملف ليس صورة.',
  studio_image_limit: 'يمكن إضافة 20 صورة محتوى كحد أقصى.',
  studio_topic_required: 'يجب أن يتكون الموضوع من 3 أحرف على الأقل.',
  studio_country_invalid: 'يجب أن تكون الدولة رمزًا من حرفين (مثل TR).',
  studio_source_url_invalid: 'يجب أن يكون رابط المصدر عنوانًا صالحًا يبدأ بـ http:// أو https://.',
  studio_too_many_sources: 'يمكن إضافة 20 مصدرًا كحد أقصى.',
  studio_draft_too_long: 'يمكن أن تتكون المسودة من 100,000 حرف كحد أقصى.',
  studio_path_invalid: 'يجب أن يكون الرابط الداخلي مسارًا داخل الموقع يبدأ بـ «/».',
  studio_archived: 'المشروع مؤرشف؛ ولا يمكن تغييره.',
  studio_draft_empty: 'اكتب مسودة أولًا قبل النقل.',
  studio_draft_invalid: 'تعذّر تحويل المسودة إلى صيغة المدونة (طويلة جدًا أو تحتوي على عناصر كثيرة جدًا).',
  studio_no_sources: 'لا توجد مصادر للتحقق منها. أضف المصادر واحفظ أولًا.',
  studio_overwrite_confirm: 'يحتوي هذا الحقل على محتوى؛ أكّد لاستبداله.',
  studio_headings_required: 'اكتب العناوين أو أنشئ مخططًا بالذكاء الاصطناعي قبل المسودة.',
  ai_output_invalid: 'لم يكن رد الذكاء الاصطناعي بالصيغة المتوقعة؛ ولم يتغير السجل. أعد المحاولة.',
  ai_not_configured:
    'مزوّد الذكاء الاصطناعي غير متصل (يتطلب الإعداد). أدخل المفتاح من شاشة التكاملات واختبر الاتصال.',
  ai_not_enabled:
    'الذكاء الاصطناعي متوقف. يجب على مالك النشاط تحديد الحد الشهري ومنح موافقة صريحة من إعدادات الذكاء الاصطناعي.',
  ai_budget_exceeded:
    'تم بلوغ حد الإنفاق الشهري على الذكاء الاصطناعي (الحد {{limit}} USD، والمُنفَق {{spent}} USD). يمكنك رفع الحد من إعدادات الذكاء الاصطناعي.',
  ai_daily_limit: 'تم بلوغ الحد اليومي لطلبات الذكاء الاصطناعي ({{limit}}). أعد المحاولة غدًا.',
  ai_invalid_key: 'رفض المزوّد مفتاح API. جدّد المفتاح من شاشة التكاملات.',
  ai_invalid_settings: 'مفتاح API فارغ أو بصيغة غير صالحة.',
  ai_provider_rate_limited: 'تم بلوغ حد الطلبات لدى المزوّد. أعد المحاولة بعد بضع دقائق.',
  ai_provider_overloaded: 'المزوّد مشغول حاليًا. أعد المحاولة بعد قليل.',
  ai_provider_rejected: 'رفض المزوّد الطلب (ربما يكون اسم النموذج أو أحد الإعدادات خاطئًا).',
  ai_provider_timeout:
    'لم يستجب المزوّد في الوقت المحدد. احتُسب المبلغ المحجوز ضمن الإنفاق لأن الطلب ربما عولج.',
  ai_provider_unreachable: 'تعذّر الوصول إلى المزوّد. أعد المحاولة بعد قليل.',
  ai_provider_bad_response: 'تعذّرت قراءة رد المزوّد.',
  ai_output_empty: 'أعاد الذكاء الاصطناعي ردًا فارغًا. غيّر المدخلات وأعد المحاولة.',
  ai_refused: 'لم يُجب الذكاء الاصطناعي عن هذا الطلب. غيّر المدخلات وأعد المحاولة.',
  ai_model_price_missing:
    'سعر النموذج «{{model}}» غير معروف. أضفه أولًا إلى جدول الأسعار ليتسنى حساب الإنفاق.',
  ai_model_invalid: 'اسم النموذج غير صالح (أحرف لاتينية صغيرة وأرقام ونقاط وشرطات).',
  ai_ack_required: 'يجب أن تؤكد أنك تفعّل خدمة مدفوعة.',
  month_invalid: 'يجب أن يكون الشهر بصيغة YYYY-MM.',
  forecast_history: 'يجب أن يكون السجل بين 8 و104 أسابيع.',
  forecast_days: 'يجب أن يكون عدد الأيام بين 0 و365.',
  forecast_review: 'يجب أن تكون فترة المراجعة بين 1 و180 يومًا.',
  forecast_overstock: 'يجب أن يكون حد المخزون الزائد بين 30 و730 يومًا.',
  ai_limit_invalid: 'يجب أن يكون الحد الشهري بين 1 و10,000 USD.',
  ai_daily_limit_invalid: 'يجب أن يكون الحد اليومي للطلبات بين 1 و5000.',
  ai_image_reserve_invalid: 'يجب أن يكون الحد الأعلى لكل صورة بين 0.001 و5 USD.',
  recommendation_window: 'يجب أن تكون الفترة بين 30 و730 يومًا.',
  recommendation_min_buyers:
    'يجب أن يكون الحد الأدنى للمشترين المختلفين بين 2 و50 (2 على الأقل حفاظًا على الخصوصية).',
  recommendation_confidence: 'يجب أن تكون نسبة الثقة بين 0 و100.',
  recommendation_max: 'يجب أن يكون عدد التوصيات لكل منتج بين 1 و20.',
};
